module.exports = __webpack_public_path__ + "static/media/collegepep.e513536d.jfif";